"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var redux_persist_1 = require("redux-persist");
var actions_1 = require("./actions");
var server_1 = require("../../helpers/server");
var initialState = {
    isLoading: false,
    isLoadingClosingMessage: false,
    hoursReportData: [],
    timelinesReportData: [],
    closingMessageData: []
};
var reportReducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case (0, server_1.apiActions)(actions_1.Actions.HOURS_REPORT).request:
        case (0, server_1.apiActions)(actions_1.Actions.TIMELINES_REPORT).request:
            return __assign(__assign({}, state), { isLoading: true });
        case (0, server_1.apiActions)(actions_1.Actions.CLOSING_MESSAGE).request:
            return __assign(__assign({}, state), { isLoadingClosingMessage: true });
        case (0, server_1.apiActions)(actions_1.Actions.HOURS_REPORT).success:
            return __assign(__assign({}, state), { isLoading: false, hoursReportData: action.payload });
        case (0, server_1.apiActions)(actions_1.Actions.TIMELINES_REPORT).success:
            return __assign(__assign({}, state), { isLoading: false, timelinesReportData: action.payload });
        case (0, server_1.apiActions)(actions_1.Actions.CLOSING_MESSAGE).success:
            return __assign(__assign({}, state), { isLoadingClosingMessage: false, closingMessageData: action.payload });
        case (0, server_1.apiActions)(actions_1.Actions.HOURS_REPORT).fail:
        case (0, server_1.apiActions)(actions_1.Actions.TIMELINES_REPORT).fail:
            return __assign(__assign({}, state), { isLoading: false });
        case (0, server_1.apiActions)(actions_1.Actions.CLOSING_MESSAGE).fail:
            return __assign(__assign({}, state), { isLoadingClosingMessage: false, closingMessageData: [] });
        case actions_1.Actions.RESET_TIMELINES_REPORT:
            return __assign(__assign({}, state), { timelinesReportData: action.payload });
        case redux_persist_1.PURGE:
            return __assign({}, initialState);
        default: return state;
    }
};
exports.default = reportReducer;
